export const BankCodes = {
  PERF: "PERF",
  STRENGTH: "STRENGTH",
  HITTING: "HITTING",
  PITCHING: "PITCHING",
  COACHEVAL: "COACHEVAL"
};

